import { photoFocus } from "../data/siteData";

export const PhotoFrame = ({
  src,
  alt,
  label,
  className = "",
  imgClassName = "",
  eager = false,
  testId,
}) => (
  <figure
    data-testid={testId}
    className={`photo-noise group relative overflow-hidden border border-ink-600/60 bg-ink-800 ${className}`}
  >
    <img
      src={src}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      style={{ objectPosition: photoFocus(src) }}
      className={`h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03] ${imgClassName}`}
    />
    <span className="pointer-events-none absolute left-2 top-2 h-4 w-4 border-l-2 border-t-2 border-kit/80" />
    <span className="pointer-events-none absolute bottom-2 right-2 h-4 w-4 border-b-2 border-r-2 border-kit/80" />
    {label && (
      <figcaption className="absolute bottom-2 left-2 bg-ink-950/80 px-2 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-kit backdrop-blur-sm">
        {label}
      </figcaption>
    )}
  </figure>
);
